import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.orderItemsFormSection.title',
    defaultMessage: 'Products',
    description: 'Title of the order items form section',
  },
  itemsErrorMessage: {
    id: 'pages.orderItemsFormSection.itemsErrorMessage',
    defaultMessage: 'Items could not be loaded',
    description: 'Error message of loading the order items',
  },
  projectionErrorMessage: {
    id: 'pages.orderItemsFormSection.projectionErrorMessage',
    defaultMessage: 'Prices could not be loaded',
    description: 'Error message of loading the order item prices',
  },
  buttons: {
    add: {
      label: {
        id: 'actions.add',
        defaultMessage: 'Add',
        description: 'Label of the add button in the order items form section',
      },
    },
    bulkAdd: {
      label: {
        id: 'actions.bulkAdd',
        defaultMessage: 'Add in bulk',
        description: 'Label of the add in bulk button in the order items form section',
      },
    },
    refresh: {
      label: {
        id: 'actions.refresh',
        defaultMessage: 'Refresh',
        description: 'Label of the refresh button in the order items form section',
      },
    },
  },
};

export default defineMessages(translations);
